export const brokerageListings = [
  {
    id: "b_portfolio",
    type: "Mixed Portfolio",
    title: "Athens Property Portfolio",
    location: "Athens & Greek Islands",
    price: "From € 320,000",
    area: "",
    bedrooms: null,
    bathrooms: null,
    floor: null,
    year: null,
    tag: "For Sale",
    cover: process.env.PUBLIC_URL + "/images/brokerage1.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/brokerage1.jpg", process.env.PUBLIC_URL + "/images/brokerage2.jpg", process.env.PUBLIC_URL + "/images/brokerage3.jpg", process.env.PUBLIC_URL + "/images/brokerage4.jpg"],
    desc: "A curated selection of residential, commercial and land properties across Athens and the Greek islands. Contact us for the full list of available properties.",
    features: ["Apartments", "Commercial", "Land Plots", "Athens", "Mykonos", "Athens Riviera"],
  },
  {
    id: "b_arkadon",
    type: "Apartment Building",
    title: "Αρκάδων 23 — Apartment Building",
    location: "Arkadwn 23, Athens",
    price: "€ 800,000",
    area: "",
    bedrooms: null,
    bathrooms: null,
    floor: null,
    year: null,
    tag: "For Sale",
    cover: process.env.PUBLIC_URL + "/images/cp_arkadon_1.jpg",
    gallery: [
      process.env.PUBLIC_URL + "/images/cp_arkadon_1.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_2.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_3.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_4.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_5.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_6.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_7.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_8.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_9.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_10.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_11.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_12.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_13.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_14.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_15.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_16.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_17.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_18.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_19.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_20.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_21.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_22.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_23.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_24.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_25.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_26.jpg",
      process.env.PUBLIC_URL + "/images/cp_arkadon_27.jpg",
    ],
    desc: "An exceptional investment opportunity — a fully furnished 7-apartment building in Athens, offered for sale as a complete asset. Each unit is styled and ready for short-term rental or long-term use.",
    features: ["7 Apartments", "Fully Furnished", "Investment Property", "Airbnb Ready", "Athens Centre"],
  },
];
